import { mixed, object } from 'yup'
import { t } from 'ttag'

import { FILE_FIELD } from './model'
import { XLSX_MAX_FILE_SIZE_BYTES, XLSX_MAX_FILES } from 'utils/sheet'

export const getSchema = () =>
  object().shape({
    [FILE_FIELD]: mixed()
      .test(
        'required',
        t`This field cannot be empty.`,
        value => (value && value.length) > 0,
      )
      .test(
        'max-files',
        t`You can upload at most ${XLSX_MAX_FILES} files at once.`,
        value => !value || value.length <= XLSX_MAX_FILES,
      )
      .test(
        'max-file-size',
        t`Each file must be smaller than ${
          XLSX_MAX_FILE_SIZE_BYTES / (1024 * 1024)
        }MB.`,
        value =>
          !value ||
          Array.from(value).every(
            file =>
              typeof file.size !== 'number' ||
              file.size <= XLSX_MAX_FILE_SIZE_BYTES,
          ),
      ),
  })
